module.exports = __webpack_public_path__ + "img/icon_menu-close.d886b873.svg";